import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

export const ratoeiraAccessGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.canSeeRatoeira() ? true : router.parseUrl('/v2/painel');
};

export const projetoHomeGuard: CanActivateFn = (route) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const projetoId = route.parent?.paramMap.get('projetoId');

    if (!projetoId) {
        return router.parseUrl('/v2/projetos');
    }

    const page = authService.canSeeRatoeira() ? 'ratoeiras' : 'tag-ratoeira/list';
    return router.parseUrl(`/v2/projetos/${projetoId}/${page}`);
};
